import React from 'react';
import { HighlightedRecommendations } from '../HighlightedRecommendations/HighlightedRecommendations';
import { type RecommendationsProps } from '../Recommendations.types';
import { TROPHY_GIF_PATH, SOURCE_COMPONENT } from './SellersWhoSpeak.constants';
import { useSellersWhoSpeakRecommendationsTexts } from './hooks';
import './styles.scss';

export const SellersWhoSpeakRecommendations: React.FC<RecommendationsProps> = ({
    listings,
    gigs = [],
    assumedLanguage = '',
    isLoading = false,
    isNarrowView = false,
}) => {
    const { title, description } = useSellersWhoSpeakRecommendationsTexts(assumedLanguage);

    const componentNameWithLanguage = assumedLanguage ? `${SOURCE_COMPONENT}_${assumedLanguage}` : SOURCE_COMPONENT;

    return (
        <HighlightedRecommendations
            className="sellers-who-speak-recommendations"
            title={title}
            description={description}
            listings={listings}
            gigs={gigs}
            componentName={componentNameWithLanguage}
            displayISpeak={true}
            shouldSendRecommendations={false}
            iconPath={TROPHY_GIF_PATH}
            isLoading={isLoading}
            isNarrowView={isNarrowView}
        />
    );
};
